import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SupabaseService } from '../shared/services/supabase.service';

export const signedInGuard: CanActivateFn = async () => {
  const supabase = inject(SupabaseService);
  const router = inject(Router);

  const { data } = await supabase.supabase.auth.getSession();
  if (data.session) {
    supabase.session.set(data.session);
    return router.createUrlTree(['/']);
  }
  return true;
};
